// Upload branding assets (logo, company chop, signature) to Emergent Object Storage via backend.
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

export const absUrl = (url) => (!url ? '' : url.startsWith('http') || url.startsWith('data:') ? url : `${BACKEND}${url}`);

export const uploadAsset = async (fileOrBlob, kind, filename) => {
  const fd = new FormData();
  const name = filename || fileOrBlob.name || `${kind}.png`;
  fd.append('file', fileOrBlob, name);
  fd.append('kind', kind);
  const res = await axios.post(`${API}/assets/upload`, fd, { withCredentials: true });
  return absUrl(res.data.url);
};
